var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Trends"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.39393 18.1794L1.79663 16.5881L9.42981 8.91088L13.4298 12.9109L18.3309 8.04783H15.7966V5.77283H22.2032V12.1734H19.9282V9.63913L13.4298 16.1435L9.42981 12.1435L3.39393 18.1794Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrend);
export default __webpack_public_path__ + "static/media/icon-trend.54bb4c73f0ddec88e49f2310c0cf9a22.svg";
export { ForwardRef as ReactComponent };